import { lazy } from 'react';
import { matchPath, Navigate, useLocation } from 'react-router-dom';
import { LoadingOverlay } from '@mantine/core';
import { Analysis } from '@/views/Analysis';
import { PROJECT_DEMO_PATHS } from '@/app/constants';
import { ProjectDemoContext } from '@/features/projectDemo';
import { useAppFlags } from '@/hooks/useAppFlags';
import { useLDIdentified } from '@/hooks/useLDIdentified';

const ProjectDemoAnalysis = lazy(
  () => import('@/views/projectDemo/ProjectDemoAnalysis')
);

export const AnalysisRoute = () => {
  const { flagProjectDemo } = useAppFlags();
  const isIdentified = useLDIdentified();
  const { pathname } = useLocation();
  const isDemoOnlyPath = PROJECT_DEMO_PATHS.some((path) =>
    matchPath(path, pathname)
  );

  if (!isIdentified) {
    if (!isDemoOnlyPath) return <Analysis />;
    return <LoadingOverlay visible overlayProps={{ backgroundOpacity: 1 }} />;
  }

  if (!flagProjectDemo) {
    return isDemoOnlyPath ? <Navigate to="/404" replace /> : <Analysis />;
  }

  return (
    <ProjectDemoContext.Provider value={true}>
      <ProjectDemoAnalysis />
    </ProjectDemoContext.Provider>
  );
};
